import classNames from "classnames";
import { useRef, useState } from "react";
import styles from "./ImageUpload.module.scss";

export const ImageUpload = ({ initialImage, onChange }) => {
  const [imagePreview, setImagePreview] = useState("");
  const inputRef = useRef(null);

  const changeHandler = (event) => {
    const files = event.currentTarget.files;
    const imageFile = files && files[0];
    if (!imageFile) {
      return;
    }
    setImagePreview(window.URL.createObjectURL(imageFile));
    onChange(imageFile);
  };

  const clickHandler = () => {
    inputRef?.current?.click();
  };

  return (
    <>
      <div className={classNames(styles.container)}>
        {!imagePreview && !initialImage && (
          <button
            type="button"
            className={styles.imagePreview}
            onClick={clickHandler}
          >
            Click here to add photo
          </button>
        )}
        {!imagePreview && initialImage && (
          <img
            src={process.env.REACT_APP_IMAGE_URL + "/" + initialImage}
            alt=""
            onClick={clickHandler}
          />
        )}
        {imagePreview && (
          <>
            <img
              src={imagePreview}
              alt=""
              onClick={clickHandler}
            />
            {/* <X className={styles.removeButton} /> */}
          </>
        )}
      </div>
      <input
        id="image"
        name="imageFile"
        type="file"
        accept="image/png, image/jpeg"
        onChange={(event) => changeHandler(event)}
        ref={inputRef}
        className={styles.fileInput}
      />
    </>
  );
};
